import { useAppSelector } from "@/redux/store";
import { Spin } from "antd";
import React from "react";
import { createPortal } from "react-dom";
import styled from "styled-components";

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(2px);
  z-index: 1005;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-in-out;

  @media (prefers-color-scheme: dark) {
    background-color: rgba(0, 0, 0, 0.8);
  }
`;

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 120px;

  @media (prefers-color-scheme: dark) {
    background: #1f1f1f;
    border: 1px solid #333;
  }
`;

const StyledText = styled.div`
  color: #666;
  font-size: 14px;
  font-weight: 500;

  @media (prefers-color-scheme: dark) {
    color: #ccc;
  }
`;

function GlobalLoading() {
  const { api } = useAppSelector(state => state);

  if (!api.loading) {
    return null;
  }

  return createPortal(
    <StyledOverlay>
      <StyledContent>
        <Spin size="large" />
        <StyledText>Loading...</StyledText>
      </StyledContent>
    </StyledOverlay>,
    document.body,
  );
}

export default GlobalLoading;
